import { useState } from 'react';
import SynergyHint from './SynergyHint';
import IngredientFamilyRow from './IngredientFamilyRow';
import { CAPACITY_PANEL_TIP } from '../utils/capacityGuidance';

function IngredientPanel({
  group,
  selectedIngredients,
  onToggle,
  onQualityChange,
  onOpenModal,
  showCapacityTip,
  onDismissCapacityTip,
  showSynergyTip = false,
  synergySuggestions = [],
  synergySelectedCount = 0,
  synergySingleName = null,
  suggestedFamilyKeys = null,
  onJumpToFamily,
}) {
  const [preferredQuality, setPreferredQuality] = useState({});

  const handlePreferredQuality = (familyKey, quality) => {
    setPreferredQuality((prev) => ({ ...prev, [familyKey]: quality }));
  };

  return (
    <div className="category-panel" style={{ gridColumn: '1 / -1' }}>
      {showCapacityTip && (
        <p className="category-panel__capacity-tip" role="note">
          <span className="category-panel__capacity-tip-text">{CAPACITY_PANEL_TIP}</span>
          <button
            type="button"
            className="category-panel__capacity-tip-dismiss"
            onClick={onDismissCapacityTip}
            aria-label="Dismiss tip"
          >
            Got it
          </button>
        </p>
      )}
      {showSynergyTip && onJumpToFamily && (
        <SynergyHint
          selectedCount={synergySelectedCount}
          singleSelectedName={synergySingleName}
          suggestions={synergySuggestions}
          onJumpToFamily={onJumpToFamily}
        />
      )}
      <div className="ingredient-list">
        {group.ingredients.map((family) => (
          <IngredientFamilyRow
            key={family.familyKey}
            family={family}
            selectedIngredients={selectedIngredients}
            preferredQuality={preferredQuality[family.familyKey]}
            onPreferredQuality={handlePreferredQuality}
            onToggle={onToggle}
            onQualityChange={onQualityChange}
            onOpenModal={onOpenModal}
            isSynergy={
              suggestedFamilyKeys != null &&
              suggestedFamilyKeys.has(family.familyKey)
            }
          />
        ))}
      </div>
    </div>
  );
}

export default IngredientPanel;
